import { render, staticRenderFns } from "./sign-up-record-list.html?vue&type=template&id=f4b10e74&scoped=true&external"
import script from "./sign-up-record-list.js?vue&type=script&lang=js&external"
export * from "./sign-up-record-list.js?vue&type=script&lang=js&external"
import style0 from "./sign-up-record-list.scss?vue&type=style&index=0&id=f4b10e74&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4b10e74",
  null
  
)

export default component.exports